import { hasAdminRole } from '@/types/auth'

/** 管理端「系统配置 → 账号安全」 */
export const ADMIN_ACCOUNT_SECURITY_PATH = '/admin/system-config/account'
/** 用户端「账号设置 → 密码安全」 */
export const USER_SECURITY_PATH = '/settings/security'

/**
 * 改密入口按角色分流。
 *
 * 顶栏下拉与登录页强制改密引导共用此处：分流写两遍的话，改路由必然漏一处，
 * 管理员就会被自己的入口赶回用户端页面。
 */
export function passwordPagePath(role: string | undefined | null): string {
  return hasAdminRole(role) ? ADMIN_ACCOUNT_SECURITY_PATH : USER_SECURITY_PATH
}

/** 强制改密引导目标：入口路径 + 直达高亮标记（面板据此展示强制改密横幅） */
export function forceChangePasswordPath(role: string | undefined | null): string {
  return `${passwordPagePath(role)}?forceChange=1`
}
